import {useContext} from 'react';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {
    propertyCardViewEvent,
    propertyCardClickEvent,
    destinationCardClickEvent,
} from '../utils/edapLegacy/edapEventsLegacy';
import {
    getCardClickEventLabelData,
    getCardViewEventLabelData,
} from '../utils/edapLegacy/edapHelpersLegacy';

export default function useEdapEvent() {
    const context = useContext(TrackingContext);

    return {
        propertyCardViewEvent: (hit) =>
            propertyCardViewEvent(context, getCardViewEventLabelData(hit)),
        propertyCardClickEvent: (hit) =>
            propertyCardClickEvent(context, getCardClickEventLabelData(hit)),
        destinationCardClickEvent: (hit) =>
            destinationCardClickEvent(context, hit),
    };
}
